import React from 'react';
import { IObjColor } from '.';

interface SalesPageProps {
  grupoId: number;
  color: IObjColor;
}

export const SalesPage: React.FC<SalesPageProps> = ({ grupoId, color }) => {
  return (
    <iframe
      key={`${color.title}-${color.primary}-${color.secondary}`}
      src={`${process.env.REACT_APP_VENDAS_URL}/${grupoId}`}
      width="100%"
      height="600px"
    />
  );
};
